// LETTER size as per ReactPDF:
// Source https://github.com/diegomura/react-pdf/blob/3f5bf67d84ee784b6685cf603f04ac5f568a146d/packages/layout/src/page/getSize.js#L10

export const PAGE_WIDTH = 612;
export const PAGE_HEIGHT = 792;
